// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { CreateEncounterScribeSessionFieldValueRequest } from './create-encounter-scribe-session-field-value-request';

/** See com.rev360.pms.api.controller.encounter.scribe.CreateEncounterScribeSessionRequest */
/* istanbul ignore next */
@GandalfModel
export class CreateEncounterScribeSessionRequest extends GandalfModelBase {

	@GandalfLabel('Encounter')
	@GandalfValidator({ notNull: { message: 'Encounter is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	encounterId!: number;

	@GandalfLabel('External Identifier')
	@GandalfValidator({ notNull: { message: 'External Identifier is required' } })
	@GandalfValidator({ sizeString: { message: 'External Identifier must be between 1 and 255 characters', minLength: 1, maxLength: 255 } })
	@GandalfProperty({ designType: String, isRequired: true })
	externalIdentifier!: string;

	@GandalfConstantDecorator(constants.EncounterScribeSessionExternalSource)
	@GandalfLabel('External Source')
	@GandalfValidator({ notNull: { message: 'External Source is required' } })
	@GandalfProperty({ designType: constants.EncounterScribeSessionExternalSource, isRequired: true })
	externalSource!: constants.EncounterScribeSessionExternalSource;

	@GandalfLabel('Fields')
	@GandalfValidator({ notNull: { message: 'Fields is required' } })
	@GandalfArray(CreateEncounterScribeSessionFieldValueRequest)
	fieldValues!: CreateEncounterScribeSessionFieldValueRequest[];

}
